'use strict';

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import indexBy from 'lodash.indexby';

import allNutrients from '@app/tables/nutrients';
import { roundForHumans } from '@utils/Math';
import Dropdown from '@pro/components/Widgets/Dropdown.react';

import './ComplianceViolations.scss';

const ComplianceViolations = ({ mealType, violations }) => {
    const renderViolation = useCallback((violation, key) => {
        const nutrient = allNutrients[violation.nutrient_number];

        if (!nutrient) {
            return null;
        }

        // Handle both meal-level and daily-level violations
        if (violation.type === 'meal_minimum_not_met' || violation.type === 'daily_minimum_not_met') {
            return (
                <li key={key}>
                    {roundForHumans(violation.deficit)} {nutrient.Units} <em>{violation.nutrient_name || nutrient.NutrDesc}</em> too few
                </li>
            );
        }

        if (violation.type === 'meal_maximum_exceeded' || violation.type === 'daily_maximum_exceeded') {
            return (
                <li key={key}>
                    {roundForHumans(violation.excess)} {nutrient.Units} <em>{violation.nutrient_name || nutrient.NutrDesc}</em> too much
                </li>
            );
        }

        return null;
    }, []);

    if (!violations || violations.length <= 0) {
        return <span/>;
    }

    return (
        <div className="customizer-compliance-violations-list">
            <div className="customizer-compliance-violations-part">
                <p>{mealType}</p>

                <ul>
                    {violations.map(renderViolation)}
                </ul>
            </div>
        </div>
    );
};

ComplianceViolations.propTypes = {
    mealType: PropTypes.string.isRequired,
    violations: PropTypes.array,
};

export default ComplianceViolations;
